<template id="filter-date-wrapper">
  <div class="px-4 py-4 border-t border-grey-lighter lg:w-1/3 xl:border-t-0 xl:w-full lg:pt-6 lg:pb-4">
    <date-picker class="w-full"
      mode="range"
      v-model="range"
      tint-color="#1f9d55"
      :is-inline="true"
      :theme-styles="styling"
      :show-day-popover="false"
      :from-page="currentPage"
      @input="add"
      is-expanded
    >
    </date-picker>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus';
import { mapState } from 'vuex';
import { setupCalendar, DatePicker } from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';

export default {
  template: '#filter-date-wrapper',
  name: 'FilterDate',
  components: { DatePicker },
  data() {
    return {
      range: null,
      styling: {
        wrapper: {
          background: '#fff',
          border: '0',
          borderRadius: '0',
          padding: '0'
        },
        header: {
          padding: '0rem 1rem 1rem 1rem',
          color: '#606f7b'
        },
        headerTitle: {
          fontSize: '1rem',
          letterSpacing: '.05rem',
          textTransform: 'uppercase',
          fontWeight: '600'
        },
        weekdays: {
          fontWeight: '600',
          color: '#606f7b'
        },
        dayContent: {
          fontSize: '.875rem',
          color: '#606f7b',
          borderRadius: '.25rem'
        }
      }
    };
  },
  created() {
    this.setup();
    setupCalendar();

    EventBus.$on('filter-deleted', this.remove);
    EventBus.$on('filter-reset', this.reset);
  },
  beforeDestroy() {
    EventBus.$off('filter-deleted', this.remove);
    EventBus.$off('filter-reset', this.reset);
  },
  computed: {
    ...mapState('subject', {
      filters: state => state.filters
    }),
    currentPage() {
      if (!this.range) return null;

      let date = this.$moment(this.range.end);

      return {
        month: date.month() + 1,
        year: date.year()
      };
    }
  },
  methods: {
    setup() {
      let selected = this.filters['filter[reporting_date]'];

      if (!selected) {
        return this.reset();
      }

      this.range = {
        start: this.$moment(selected.label.start).format('Y-MM-DD'),
        end: this.$moment(selected.label.end).format('Y-MM-DD')
      };
    },
    add(date) {
      let filterStart = this.$moment(date.start).format('Y-MM-DD');
      let filterEnd = this.$moment(date.end).format('Y-MM-DD');

      this.$emit('selected', {
        type: 'reporting_date',
        label: this.range,
        value: `gte:${filterStart}|ste:${filterEnd}`
      });
    },
    remove(filter) {
      if (filter == 'filter[reporting_date]') {
        this.range = null;
      }
    },
    reset() {
      this.range = null;
    }
  }
};
</script>
